import { render, staticRenderFns } from "./login-pending.vue?vue&type=template&id=87106bba&scoped=true"
import script from "./login-pending.vue?vue&type=script&lang=js"
export * from "./login-pending.vue?vue&type=script&lang=js"
import style0 from "./login-pending.vue?vue&type=style&index=0&id=87106bba&prod&scoped=true&lang=css"
import style1 from "./login-pending.vue?vue&type=style&index=1&id=87106bba&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87106bba",
  null
  
)

export default component.exports